import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Posts API
export const postsAPI = {
  getAll: (category = null, limit = null, has_image = false, skip = 0, exclude_sponsored = false) => 
    axios.get(`${API}/posts`, { params: { ...(category && { category }), ...(limit && { limit }), ...(has_image && { has_image: true }), ...(skip && { skip }), ...(exclude_sponsored && { exclude_sponsored: true }) }, headers: getAuthHeader() }),
  
  getCount: (category = null) =>
    axios.get(`${API}/posts/count`, { params: { ...(category && { category }) } }),
  
  search: (q, limit = 24, skip = 0, category) => {
    const params = { q, limit, skip };
    if (category) params.category = category;
    return axios.get(`${API}/posts/search`, { params });
  },
  
  getById: (id) => 
    axios.get(`${API}/posts/${id}`, { headers: getAuthHeader() }),
  
  getBySlug: (slug) => 
    axios.get(`${API}/posts/slug/${slug}`, { headers: getAuthHeader() }),
  
  create: (data) => 
    axios.post(`${API}/posts`, data, { headers: getAuthHeader() }),
  
  update: (id, data) => 
    axios.put(`${API}/posts/${id}`, data, { headers: getAuthHeader() }),
  
  delete: (id) => 
    axios.delete(`${API}/posts/${id}`, { headers: getAuthHeader() })
};

// Stats API
export const statsAPI = {
  get: () => axios.get(`${API}/stats`),
  update: (data) => axios.put(`${API}/stats`, data, { headers: getAuthHeader() })
};

// Businesses API
export const businessesAPI = {
  getAll: () => axios.get(`${API}/businesses`),
  create: (data) => axios.post(`${API}/businesses`, data, { headers: getAuthHeader() }),
  update: (id, data) => axios.put(`${API}/businesses/${id}`, data, { headers: getAuthHeader() }),
  delete: (id) => axios.delete(`${API}/businesses/${id}`, { headers: getAuthHeader() })
};

// Advertisers API
export const advertisersAPI = {
  getAll: () => axios.get(`${API}/advertisers`),
  create: (data) => axios.post(`${API}/advertisers`, data, { headers: getAuthHeader() }),
  update: (id, data) => axios.put(`${API}/advertisers/${id}`, data, { headers: getAuthHeader() }),
  delete: (id) => axios.delete(`${API}/advertisers/${id}`, { headers: getAuthHeader() })
};

// Supporters API
export const supportersAPI = {
  getAll: () => axios.get(`${API}/supporters`),
  create: (data) => axios.post(`${API}/supporters`, data, { headers: getAuthHeader() }),
  update: (id, data) => axios.put(`${API}/supporters/${id}`, data, { headers: getAuthHeader() }),
  delete: (id) => axios.delete(`${API}/supporters/${id}`, { headers: getAuthHeader() })
};

// Featured Sections API
export const featuredAPI = {
  getAll: () => axios.get(`${API}/featured`),
  create: (data) => axios.post(`${API}/featured`, data, { headers: getAuthHeader() }),
  update: (id, data) => axios.put(`${API}/featured/${id}`, data, { headers: getAuthHeader() }),
  delete: (id) => axios.delete(`${API}/featured/${id}`, { headers: getAuthHeader() })
};


// Events API
export const eventsAPI = {
  list: (params = {}) => axios.get(`${API}/events`, { params }),
  count: (params = {}) => axios.get(`${API}/events/count`, { params }),
  adminList: () => axios.get(`${API}/admin/events`, { headers: getAuthHeader() }),
  upcoming: (limit = 6, exclude = '') => axios.get(`${API}/events/upcoming`, { params: { limit, ...(exclude ? { exclude } : {}) } }),
  bySlug: (slug) => axios.get(`${API}/events/slug/${slug}`),
  getById: (id) => axios.get(`${API}/events/${id}`, { headers: getAuthHeader() }),
  create: (data) => axios.post(`${API}/events`, data, { headers: getAuthHeader() }),
  update: (id, data) => axios.put(`${API}/events/${id}`, data, { headers: getAuthHeader() }),
  delete: (id) => axios.delete(`${API}/events/${id}`, { headers: getAuthHeader() }),
  importCSV: (formData) => axios.post(`${API}/admin/events/import-csv`, formData, {
    headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
  }),
  previewRecurring: (data) => axios.post(`${API}/events/generate-recurring/preview`, data, { headers: getAuthHeader() }),
  generateRecurring: (data) => axios.post(`${API}/events/generate-recurring`, data, { headers: getAuthHeader() }),
  submitCommunity: (formData) => axios.post(`${API}/events/submit`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  verifySubmission: (token) => axios.get(`${API}/events/verify/${token}`),
};

// About / Discover Paisley content
export const aboutAPI = {
  get: () => axios.get(`${API}/about`),
  update: (data) => axios.put(`${API}/admin/about`, data, { headers: getAuthHeader() }),
};

// Broadcast + Digest emails API
export const broadcastAPI = {
  digestPreview: () => axios.get(`${API}/admin/digest/preview`, { headers: getAuthHeader() }),
  digestSend: () => axios.post(`${API}/admin/digest/send`, {}, { headers: getAuthHeader() }),
  digestHistory: () => axios.get(`${API}/admin/digest/history`, { headers: getAuthHeader() }),
  sendTest: (data) => axios.post(`${API}/admin/broadcast/test`, data, { headers: getAuthHeader() }),
  send: (data) => axios.post(`${API}/admin/broadcast/send`, data, { headers: getAuthHeader() }),
  history: () => axios.get(`${API}/admin/broadcast/history`, { headers: getAuthHeader() }),
};

// ClydeFlow Import API
export const clydeflowAPI = {
  parse: (formData) => axios.post(`${API}/admin/clydeflow/parse`, formData, {
    headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
  }),
  runImport: (data) => axios.post(`${API}/admin/clydeflow/import`, data, { headers: getAuthHeader() }),
  history: () => axios.get(`${API}/admin/clydeflow/history`, { headers: getAuthHeader() }),
  drafts: () => axios.get(`${API}/admin/clydeflow/drafts`, { headers: getAuthHeader() }),
  publishDrafts: (data) => axios.post(`${API}/admin/clydeflow/drafts/publish`, data, { headers: getAuthHeader() }),
  getSettings: () => axios.get(`${API}/admin/clydeflow/settings`, { headers: getAuthHeader() }),
  putSettings: (data) => axios.put(`${API}/admin/clydeflow/settings`, data, { headers: getAuthHeader() }),
  driveStatus: () => axios.get(`${API}/admin/clydeflow/drive/status`, { headers: getAuthHeader() }),
  driveConnect: () => axios.get(`${API}/admin/clydeflow/drive/connect`, { headers: getAuthHeader() }),
  driveServiceAccount: (data) => axios.post(`${API}/admin/clydeflow/drive/service-account`, data, { headers: getAuthHeader() }),
  driveSyncNow: () => axios.post(`${API}/admin/clydeflow/drive/sync-now`, {}, { headers: getAuthHeader() }),
  driveDisconnect: () => axios.delete(`${API}/admin/clydeflow/drive`, { headers: getAuthHeader() }),
};

// Properties to Let API
export const propertiesAPI = {
  list: (params = {}) => axios.get(`${API}/properties`, { params }),
  latest: (limit = 6) => axios.get(`${API}/properties/latest`, { params: { limit } }),
  bySlug: (slug) => axios.get(`${API}/properties/slug/${slug}`),
  adminList: () => axios.get(`${API}/admin/properties`, { headers: getAuthHeader() }),
  getById: (id) => axios.get(`${API}/properties/${id}`, { headers: getAuthHeader() }),
  create: (data) => axios.post(`${API}/properties`, data, { headers: getAuthHeader() }),
  update: (id, data) => axios.put(`${API}/properties/${id}`, data, { headers: getAuthHeader() }),
  delete: (id) => axios.delete(`${API}/properties/${id}`, { headers: getAuthHeader() }),
  importCSV: (formData) => axios.post(`${API}/admin/properties/import-csv`, formData, {
    headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
  }),
  rightmoveSync: () => axios.post(`${API}/admin/rightmove/sync`, null, { headers: getAuthHeader(), timeout: 120000 }),
  rightmoveStatus: () => axios.get(`${API}/admin/rightmove/status`, { headers: getAuthHeader() }),
  otmSync: () => axios.post(`${API}/admin/otm/sync`, null, { headers: getAuthHeader(), timeout: 120000 }),
  otmStatus: () => axios.get(`${API}/admin/otm/status`, { headers: getAuthHeader() }),
  rentalsSyncAll: () => axios.post(`${API}/admin/rentals/sync-all`, null, { headers: getAuthHeader(), timeout: 240000 }),
};

